export const RESET = 'EXCMCUSTOMFIELDVALUE_UPDATE_RESET'
export const SET_ERROR = 'EXCMCUSTOMFIELDVALUE_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXCMCUSTOMFIELDVALUE_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXCMCUSTOMFIELDVALUE_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXCMCUSTOMFIELDVALUE_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXCMCUSTOMFIELDVALUE_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXCMCUSTOMFIELDVALUE_UPDATE_UPDATE_RETRIEVED'
